(function() {

// Animate elements with a slide effect
animateOnViewportEntry(['h2'], { type: 'slide-fade', distance: 60 });

// Animate elements with a default fade effect
animateOnViewportEntry(['p'], { type: 'slide-fade', distance: 50 });


})();